import { debounce } from "es-toolkit/compat";
import { useCallback, useEffect, useRef } from "react";

const useDebouncedCallback = <C extends (...args: any[]) => void>(
  callback: C,
  delay: number,
) => {
  const debouncedCallbackRef = useRef(debounce(callback, delay));

  useEffect(() => {
    debouncedCallbackRef.current = debounce(callback, delay);
  }, [callback, delay]);

  return useCallback((...args: Parameters<C>) => {
    debouncedCallbackRef.current(...args);
  }, []);
};

export default useDebouncedCallback;
